import React, { useState } from 'react'

import LogoutIcon from '../../icons/logout.svg?react'
import { logout } from '../../modules/apiclient'
import { ContactAvatar } from '../contacts/ContactAvatarV1'
import { PSApplication } from './PSApplication'

/** @deprecated */
export const UserHeader: React.FC = () => {
    const [isMenuOpen, setMenuOpen] = useState(false)

    const loginInfo = PSApplication.me()

    if (!loginInfo) return <span />

    const userImage = loginInfo.image?.uri ? (
        <img
            width="36"
            height="36"
            style={{
                borderRadius: '50%',
                marginTop: '-8px',
                border: '0.5px solid rgba(0, 0, 0, 0.15)',
            }}
            alt={loginInfo.name}
            src={loginInfo.image.uri}
        />
    ) : (
        <ContactAvatar user={loginInfo} size="small" style={{ marginTop: '-6px' }} />
    )

    return (
        <div style={{ display: 'flex' }}>
            <span
                onClick={() => setMenuOpen((s) => !s)}
                style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
            >
                <div style={{ marginRight: '16px', fontSize: '15px', color: '#000000' }}>
                    {loginInfo.name}
                </div>
                <span style={{ width: '36px', height: '36px' }}>{userImage}</span>
            </span>
            <div
                style={{
                    display: isMenuOpen ? 'block' : 'none',
                    position: 'absolute',
                    zIndex: 100000,
                    boxShadow: '0px 14px 14px rgba(0, 0, 0, 0.07)',
                    borderRadius: '18px',
                    width: '250px',
                    top: '60px',
                    left: 'calc(100% - 273px)',
                    backgroundColor: '#ffffff',
                    padding: '20px',
                }}
            >
                <span style={{ cursor: 'pointer' }}>
                    <LogoutIcon />
                    <span
                        style={{
                            color: '#E22216',
                            fontSize: '15px',
                            marginLeft: '8px',
                            verticalAlign: 'text-bottom',
                        }}
                        onClick={async () => await logout()}
                    >
                        Logout
                    </span>
                </span>
            </div>
        </div>
    )
}
